import { render, staticRenderFns } from "./retunPudDetail.vue?vue&type=template&id=807a6f94&scoped=true&"
import script from "./retunPudDetail.vue?vue&type=script&lang=js&"
export * from "./retunPudDetail.vue?vue&type=script&lang=js&"
import style0 from "./retunPudDetail.vue?vue&type=style&index=0&id=807a6f94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807a6f94",
  null
  
)

export default component.exports